import axios from "axios";
import api from "lib/api/api";
import {
  APPROVE_COURSE_FAILURE,
  APPROVE_COURSE_SUCCESS,
  FETCH_APPROVED_COURSES_FAILURE,
  FETCH_APPROVED_COURSES_REQUEST,
  FETCH_APPROVED_COURSES_SUCCESS,
  FETCH_PENDING_COURSES_FAILURE,
  FETCH_PENDING_COURSES_REQUEST,
  FETCH_PENDING_COURSES_SUCCESS,
  MARK_COURSE_PENDING_FAILURE,
  MARK_COURSE_PENDING_SUCCESS,
} from "./types";

// Fetch pending courses
export const fetchPendingCourses = () => async (dispatch) => {
  dispatch({ type: FETCH_PENDING_COURSES_REQUEST });
  try {
    const response = await api.get(`/admin/pending`);
    dispatch({ type: FETCH_PENDING_COURSES_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({
      type: FETCH_PENDING_COURSES_FAILURE,
      payload:
        error.response?.data?.message || "Failed to fetch pending courses",
    });
  }
};

// Fetch approved courses
export const fetchApprovedCourses = () => async (dispatch) => {
  dispatch({ type: FETCH_APPROVED_COURSES_REQUEST });
  try {
    const response = await api.get(`/admin/approvals`);
    dispatch({ type: FETCH_APPROVED_COURSES_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({
      type: FETCH_APPROVED_COURSES_FAILURE,
      payload:
        error.response?.data?.message || "Failed to fetch approved courses",
    });
  }
};

// Approve a course (using teacherCourseId)
export const approveCourse = (teacherCourseId) => async (dispatch) => {
  try {
    await axios.put(
      `${process.env.REACT_APP_API_URL}/api/admin/approve/${teacherCourseId}`
    );
    dispatch({ type: APPROVE_COURSE_SUCCESS, payload: teacherCourseId });
  } catch (error) {
    dispatch({ type: APPROVE_COURSE_FAILURE, payload: error.message });
  }
};

// Mark course as pending (using teacherCourseId)
export const markCoursePending = (teacherCourseId) => async (dispatch) => {
  try {
    await axios.put(
      `${process.env.REACT_APP_API_URL}/api/admin/pending/${teacherCourseId}`
    );
    dispatch({ type: MARK_COURSE_PENDING_SUCCESS, payload: teacherCourseId });
  } catch (error) {
    dispatch({ type: MARK_COURSE_PENDING_FAILURE, payload: error.message });
  }
};
